export default __webpack_public_path__ + "static/media/badge-or.a9760b82.png";